/* ============================================================================
   SBD mobile nav — behaviour for snippets/sbd-mobile-nav.liquid.

   Ported from sbdapparel.com's own drawer script, plus the image filling that
   keeps this menu and the desktop mega menu reading from one source.

   Four jobs:

     1. Repurpose whichever hamburger Impulse rendered so it opens this drawer
        instead of the theme's. Cloning the node is what strips theme.js's
        binding: theme.js listens at the document for .js-drawer-open-nav, so
        simply unbinding or hiding is not enough — the class has to go, and the
        stylesheet hides the original by that same class.

     2. Accordion, one panel open at a time. When one panel closes and another
        opens, the content above the clicked row shrinks and the row slides up
        the screen, which reads as the menu jumping. The scroll position
        follows the clicked trigger for the length of the transition so it
        settles at the top of the drawer with its submenu beneath it.

     3. The men/women toggle inside a panel.

     4. Fill the banner and trust-badge placeholders from window.SBD_NAV, the
        same object snippets/sbd-nav-assets.liquid defines for the desktop nav.
        An image is therefore changed in one place and both menus follow.

   No dependency on theme.js or jQuery.
   ============================================================================ */

(function () {
  'use strict';

  var CONFIG = window.SBD_NAV || {};

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* Shopify image URLs already carry a ?v= cache key, so the width parameter
     has to join the existing query string rather than start a new one. */
  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function fillBanners(drawer) {
    var figures = CONFIG.figures || {};

    drawer.querySelectorAll('[data-sbd-mnav-banner]').forEach(function (slot) {
      var key = slot.getAttribute('data-sbd-mnav-banner');
      var gender = slot.getAttribute('data-sbd-banner-gender');
      var figure = figures[key];

      if (figure && gender) figure = figure[gender];
      if (!figure || !figure.image) return; /* left empty; the stylesheet hides it */

      var link = document.createElement('a');
      link.href = figure.url || '#';

      var img = document.createElement('img');
      img.src = sized(figure.image, 800);
      img.srcset = sized(figure.image, 600) + ' 600w, ' + sized(figure.image, 900) + ' 900w';
      img.sizes = '(max-width: 768px) 100vw, 400px';
      img.alt = '';
      img.loading = 'lazy';
      link.appendChild(img);

      if (figure.label) {
        var label = document.createElement('span');
        label.className = 'sbd-mnav__banner-label';
        label.textContent = figure.label;
        link.appendChild(label);
      }

      slot.appendChild(link);
    });
  }

  function fillIcons(drawer) {
    var icons = CONFIG.icons || [];
    var strip = drawer.querySelector('[data-sbd-mnav-icons]');
    if (!strip || !icons.length) return;

    icons.forEach(function (url) {
      var item = document.createElement('div');
      item.className = 'sbd-mnav__icon-item';

      var img = document.createElement('img');
      img.src = sized(url, 88);
      img.srcset = sized(url, 88) + ' 1x, ' + sized(url, 176) + ' 2x, ' + sized(url, 264) + ' 3x';
      img.width = 88;
      img.height = 88;
      img.alt = '';
      img.loading = 'lazy';

      item.appendChild(img);
      strip.appendChild(item);
    });
  }

  ready(function () {
    var drawer = document.getElementById('SbdMobileNav');
    if (!drawer) return;

    fillBanners(drawer);
    fillIcons(drawer);

    var lastFocus = null;

    function openDrawer() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var close = drawer.querySelector('.sbd-mnav__close');
      if (close) close.focus();
    }

    function closeDrawer() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* 1. Hamburger. Clone strips theme.js's delegated handler; dropping the
       class also lifts the stylesheet's display:none from the replacement. */
    document.querySelectorAll('.js-drawer-open-nav').forEach(function (original) {
      var clone = original.cloneNode(true);
      clone.classList.remove('js-drawer-open-nav');
      clone.removeAttribute('aria-controls');
      clone.setAttribute('data-sbd-mnav-open', '');
      clone.style.display = '';
      if (original.parentNode) original.parentNode.replaceChild(clone, original);
    });

    document.querySelectorAll('[data-sbd-mnav-open]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openDrawer();
      });
    });

    drawer.querySelectorAll('[data-sbd-mnav-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    /* 2. Accordion */
    var scrollArea = drawer.querySelector('.sbd-mnav__scroll');

    function pinTriggerToTop(btn) {
      if (!scrollArea) return;

      var DURATION = 420; /* must outlast the .sbd-mnav__sub max-height transition */
      var start = null;

      function step(timestamp) {
        if (start === null) start = timestamp;

        var target = scrollArea.scrollTop
          + (btn.getBoundingClientRect().top - scrollArea.getBoundingClientRect().top);
        if (target < 0) target = 0;

        if (timestamp - start >= DURATION) {
          scrollArea.scrollTop = target; /* final, exact position */
          return;
        }

        /* Ease towards the still-moving target rather than snapping to it */
        scrollArea.scrollTop += (target - scrollArea.scrollTop) * 0.2;
        requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    drawer.querySelectorAll('[data-sbd-mnav-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        var wasOpen = btn.classList.contains('is-open');

        drawer.querySelectorAll('[data-sbd-mnav-trigger].is-open').forEach(function (other) {
          other.classList.remove('is-open');
          other.setAttribute('aria-expanded', 'false');
          var otherSub = document.getElementById(other.getAttribute('aria-controls'));
          if (otherSub) {
            otherSub.classList.remove('is-open');
            otherSub.setAttribute('aria-hidden', 'true');
          }
        });

        if (!wasOpen && sub) {
          btn.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          sub.classList.add('is-open');
          sub.setAttribute('aria-hidden', 'false');
          pinTriggerToTop(btn);
        }
      });
    });

    /* 3. Gender toggle */
    drawer.querySelectorAll('[data-sbd-gender-toggle]').forEach(function (toggle) {
      toggle.querySelectorAll('[data-sbd-gender]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var gender = btn.getAttribute('data-sbd-gender');
          var container = btn.closest('.sbd-mnav__sub');
          if (!container) return;

          toggle.querySelectorAll('[data-sbd-gender]').forEach(function (other) {
            other.classList.remove('is-active');
            other.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          container.querySelectorAll('[data-sbd-gender-panel]').forEach(function (panel) {
            var match = panel.getAttribute('data-sbd-gender-panel') === gender;
            panel.classList.toggle('sbd-mnav__gender-panel--hidden', !match);
          });
        });
      });
    });
  });
})();
